import {ENV_NAME, GOOGLE_ID, LOG_EVENTS} from "config";
import {sendEventRequest} from "requests";
import ReactGA from "react-ga4";
import {GtmPayload, pushGTM} from "utils/gtm";
import {withinFlushBudget} from "utils/eventDelivery";

let gaInitialized = false;
const ensureGA = () => {
    // Backend measurement remains available without a GA container (tests,
    // private deployments, or an unset optional frontend environment value).
    if (!GOOGLE_ID) return;
    if (!gaInitialized) {
        ReactGA.initialize(GOOGLE_ID!);
        gaInitialized = true;
    }
};

/** Every product event: pushed to the GTM dataLayer and recorded on the backend under the same name. */
export const logEvent = async ({event: eventName, params: options}: GtmPayload) => {
    const gtmFlush = pushGTM(eventName, options);
    ensureGA();
    if (!LOG_EVENTS) {
        console.log("Event (logging disabled)", eventName, options)
        await gtmFlush;
        return
    }
    console.log("Event", eventName, options)
    const deliver = async () => {
        try {
            await sendEventRequest(eventName, options);
        } catch (e) {
            console.warn("Analytics event could not be sent")
        }
    };
    // Callers await this right before leaving the page (Google sign-in, Stripe, logout),
    // so a slow or hung backend must not hold them past the flush budget.
    await withinFlushBudget(Promise.all([gtmFlush, deliver()]));
}
(window as any).logEvent = logEvent
